<template>
  <div class="bbe-email-msg">
    <div class="bbe-email-msg-body" v-if="activeEmail.msg">
      <EmailThread
        v-if="!replyMode || activeEmail.messages.length === 1"
        :msg="activeEmail.msg[0]"
        :replyMode="replyMode"
        :length="lengthThread"
        :index="0"
      />
      <template v-if="lengthThread > 4">
        <div class="bbe-email-msg-count">
          <div class="bbe-email-msg-count-button" @click="openFullThreads">
            <i class="email-icon-arrow-point bbe-email-msg-count-button__icon"
               :class="{'bbe-email-msg-count-button__icon_rotate': !openFullThreadsStatus}"/>
            <i class="email-icon-arrow-point bbe-email-msg-count-button__icon"
               :class="{'bbe-email-msg-count-button__icon_rotate': openFullThreadsStatus}"/>
          </div>
        </div>
      </template>
      <template v-if="lengthThread > 1 && lengthThread < 5">
        <EmailThread v-for="(msg, index) in activeEmail.msg"
                     :key="index"
                     :msg="msg"
                     :length="lengthThread"
                     :index="index"
                     v-if="index > 0"/>
      </template>
      <transition-group name="bbe-thread-display">
        <template v-if="openFullThreadsStatus">
          <EmailThread v-for="(msg, index) in activeEmail.msg"
                       :noBorder="index === 1"
                       :key="index"
                       :msg="msg"
                       :length="lengthThread"
                       :index="index"
                       v-if="index > (replyMode ? -1 : 0)"/>
        </template>
      </transition-group>
      <transition name="bbe-fade-options">
        <template v-if="lengthThread > 4 && !openFullThreadsStatus">
          <EmailThread :msg="activeEmail.msg[lengthThread - 1]"
                       :noBorder="true"
                       :length="lengthThread"
                       :index="lengthThread - 1"/>
        </template>
      </transition>
      <EmailAttachments :attachments="attachments"
                        :totalFiles="countFiles.count"
                        :placeholder="countFiles.files"
                        @downloadFile="setAttachments"/>
    </div>
  </div>
</template>

<script>
import {find, get, findIndex, countBy} from 'lodash'
import EmailAttachments from '@/components/Email/EmailAttachments/EmailAttachments'
import EmailThread from '@/components/Email/EmailThread/EmailThread'
import GmailApi from '@/api/Gmail/api'
import base64 from '@/mixin/base64'
import routerPush from '@/mixin/routerPush'
import findEmails from '@/mixin/findEmails'
import headerGmail from '@/mixin/headerGmail'

export default {
  name: 'EmailMsg',
  mixins: [base64, routerPush, findEmails, headerGmail],
  props: ['replyMode'],
  components: {
    EmailThread,
    EmailAttachments
  },
  data () {
    return {
      countFiles: {
        count: 0,
        status: false,
        files: []
      },
      attachments: [],
      openFullThreadsStatus: false,
      attachmentsInset: []
    }
  },
  computed: {
    activeTab () {
      return this.$store.getters.activeTab
    },
    newMessage: {
      get () {
        return this.$store.getters.newMessage
      },
      set (data) {
        this.$store.dispatch('setNewMessage', data)
      }
    },
    activeEmail: {
      get: function () {
        return this.$store.getters.activeEmail
      },
      set: function (data) {
        this.$store.dispatch('setActiveEmail', data)
      }
    },
    attachmentsList: {
      get: function () {
        return this.$store.getters.attachmentsList
      },
      set: function (data) {
        this.$store.dispatch('setAttachmentsList', data)
      }
    },
    activeUser () {
      return this.$store.getters.userInfo || this.$store.getters.activeUser
    },
    lengthThread () {
      return get(this.activeEmail, 'msg.length', 0)
    }
  },
  methods: {
    openFullThreads () {
      this.openFullThreadsStatus = !this.openFullThreadsStatus
      this.$emit('displayThreads', this.openFullThreadsStatus)
    },
    async getAttachments ({messageId, attachmentId}) {
      if (this.attachmentsList[messageId]) {
        return this.attachmentsList[messageId]
      }
      const header = this.headerGmail()
      if (!attachmentId) return
      try {
        const { data } = await GmailApi.getAttachmentById({ header, messageId, attachmentId })
        this.attachmentsList[messageId] = data.data
        return data.data
      } catch (err) {
        console.error(err)
      }
    },
    findData (array, mime) {
      const part = find(array, {mimeType: mime})
      const data = get(part, 'body.data', '')
      const data64 = data.replace(/-/g, '+').replace(/_/g, '/')
      const decode = this.base64Decode(data64)
      return decode
    },
    async decoderParts (payload, messageId, beforeMimeType) {
      const rootMimeType = payload.mimeType
      const alternative = rootMimeType === 'multipart/alternative'
      const mixed = rootMimeType === 'multipart/mixed' || rootMimeType === 'multipart/report'
      const related = rootMimeType === 'multipart/related'
      const image = /image\/.+/gi.test(rootMimeType)
      const application = /application\/.+/gi.test(rootMimeType)
      const text = /text\/.+/gi.test(rootMimeType)
      if (alternative) {
        const textPlain = this.findData(payload.parts, 'text/plain')
        const textHtml = this.findData(payload.parts, 'text/html')
        return textHtml || textPlain
      } else if (mixed || related) {
        const result = []
        for await (let part of payload.parts) {
          const nextPart = await this.decoderParts(part, messageId, rootMimeType)
          result.push(nextPart)
        }
        return result.join(' ')
      // } else if (image || application || textHtml) {
      } else if (image || application) {
        this.countFiles.files.push({
          id: get(payload, 'body.attachmentId', false),
          name: get(payload, 'filename', 'unknown'),
          size: get(payload, 'body.size', 0),
          type: get(payload, 'mimeType', ''),
          messageId: messageId
        })
        beforeMimeType === 'multipart/related' ? this.countFiles.count += 0 : this.countFiles.count += 1
        this.imageOutput(payload, messageId, rootMimeType, beforeMimeType)
      } else if (text) {
      // } else if (text && !textHtml) {
        return this.findData([payload], rootMimeType)
      } else {
        this.imageOutput(payload, messageId, rootMimeType, beforeMimeType)
      }
    },
    async imageOutput (payload, messageId, mimeType, beforeMimeType) {
      const attachmentId = get(payload, 'body.attachmentId', '')
      const dataFile = await this.getAttachments({ messageId, attachmentId })
      if (!attachmentId) return
      const data64 = dataFile.replace(/-/g, '+').replace(/_/g, '/')
      if (beforeMimeType === 'multipart/related') {
        this.setAttachmentFile(payload, data64, mimeType, attachmentId)
      }
    },
    async decoderThread (mail) {
      const regexpStyleTag = /font-family/gmi
      this.countFiles.count = 0
      this.countFiles.files = []
      this.countFiles.status = false
      this.attachments = []
      this.attachmentsInset = []
      const htmlMessages = []
      const messages = mail.messages || []
      for await (let msg of messages) {
        const messageId = get(msg, 'id', '')
        const payload = get(msg, 'payload', [])
        const result = await this.decoderParts(payload, messageId)
        const resultWithoutStyleTag = result.replace(regexpStyleTag, '')
        htmlMessages.push(resultWithoutStyleTag)
      }
      this.$set(this.activeEmail, 'msg', htmlMessages)
      this.$set(this.activeEmail, 'attachmentsInset', this.attachmentsInset)
      this.countFiles.status = true
      this.checkDraft()
    },
    checkedFileName (filename) {
      const fileNameExists = countBy(this.attachments, 'name')
      const fileType = filename.match(/\.\w+/, '') ? filename.match(/\.\w+/, '')[0] : 'txt'
      const countName = fileNameExists[filename]
      const newFileName = filename.replace(/\.\w+/, `(${countName})${fileType}`)
      return countName > 0 ? newFileName : filename
    },
    async setAttachments (item, callback) {
      const params = {
        userId: get(this.activeUser, 'email', 'k.syndikat@gmail.com'),
        messageId: item.messageId,
        attachmentId: item.id
      }
      const fileExists = findIndex(this.attachments, {id: item.id})
      if (fileExists !== -1) {
        callback()
        return
      }
      const dataFile = await this.getAttachments(params)
      const data64 = dataFile.replace(/-/g, '+').replace(/_/g, '/')
      item.base64 = data64
      item.name = this.checkedFileName(item.name)
      this.attachments.push(item)
      this.activeEmail.attachments = this.attachments
      callback()
    },
    setAttachmentFile (payload, data64, mimeType, attachmentId) {
      const headerId = find(payload.headers, {name: 'Content-ID'})
      if (!headerId) return
      const id = headerId.value.replace(/(^<)|(>$)/gi, '')
      this.attachmentsInset.push({
        id,
        attachmentId,
        data64,
        mimeType
      })
      const src = `data:${mimeType};base64,${data64}`
      const image = document.querySelector(`IMG[src="cid:${id}"]`)
      if (!image) return
      image.src = src
    },
    checkDraft () {
      const isDraftTab = this.activeTab === 'DRAFT'
      const hasLabelDraft = get(this.activeEmail, 'labelIds', []).includes('DRAFT')
      if (!isDraftTab || !hasLabelDraft) return
      const bcc = get(this.activeEmail, 'bcc', '')
      const cc = get(this.activeEmail, 'cc', '')
      this.newMessage = {
        subject: get(this.activeEmail, 'subject', ''),
        toEmail: get(this.activeEmail, 'to.email', ''),
        copy: this.findEmails(cc).join(', '),
        copyHide: this.findEmails(bcc).join(', '),
        contents: get(this.activeEmail, ['msg', 0], ''),
        openFullSize: true
      }
      if (get(this.activeEmail, 'isDraft', '')) {
        this.newMessage.draftThreadId = get(this.activeEmail, 'id', '')
      }
    }
  },
  watch: {
    activeEmail (newVal, oldVal) {
      if (newVal === oldVal) return
      this.openFullThreadsStatus = false
      this.decoderThread(this.activeEmail)
    }
  },
  mounted () {
    this.decoderThread(this.activeEmail)
  }
}
</script>

<style lang="scss" scoped>
@import "../../../sass/variables";
@import "../../../sass/mixins";

.bbe-email-msg {
  @include global-font;
  max-width: 100%;
  margin-top: 22px;
  padding: 0 30px;

  &-header {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    margin-bottom: 22px;

    &__title {
      font-style: normal;
      font-weight: 600;
      font-size: 22px;
    }

    &__date {
      color: $color-silver-chalice;
      font-size: 14px;
    }
  }

  &-count {
    position: relative;
    display: flex;
    align-items: center;

    &-button {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 42px;
      height: 42px;
      background: $color-white;
      box-shadow: 0 0 15px rgba($color-accent, 0.12);
      border-radius: 50%;
      z-index: 1;
      transition: 0.3s;
      cursor: pointer;

      &:hover {
        box-shadow: 0 0 15px rgba($color-accent, 0.17);
      }

      &:hover &__icon {
        color: $color-accent-hover;
      }

      &__icon {
        align-items: center;
        justify-content: center;
        font-size: 10px;
        line-height: 10px;
        color: $color-accent;
        transition: 0.3s;

        &_rotate {
          transform: rotate(-180deg);
        }

        &:before {
          margin: 0;
        }
      }
    }

    &:after, &:before {
      content: '';
      position: absolute;
      top: 19px;
      right: -30px;
      height: 1px;
      width: calc(100% + 60px);
      background-color: $color-wild-sand;
    }

    &:before {
      top: auto;
      bottom: 19px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/Email/EmailMsg/EmailMsg.vue